import moment from 'moment'

export default {
  specializationStart () {
    return moment(this.specialization.start, 'YYYYMM').format('MM/YYYY')
  },
  specializationEnd () {
    return moment(this.specialization.end, 'YYYYMM').format('MM/YYYY')
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/components/professional/components/specializations/resources/computed.js